<template src="./login.component.html"></template>
<style scoped src="./login.component.css"></style>
<script lang="ts">
import Vue from 'vue';
import api from '@/api';

export default Vue.extend({
  data() {
    return {
      hidden: true,
      form: {
        email: '',
        password: '',
      },
    };
  },
  mounted() {
    document.body.classList.add(
      'min-w-site',
      'bg-40',
      'text-90',
      'font-medium',
      'min-h-full',
    );
  },
  destroyed() {
    document.body.classList.remove(
      'min-w-site',
      'bg-40',
      'text-90',
      'font-medium',
      'min-h-full',
    );
  },
  methods: {
    async login() {
      try {
        const response = await api.execute('post', '/user', {
          email: this.form.email,
          password: this.form.password,
        }) as {email: string, token: string, user: string};
        if (response) {
          localStorage.setItem('logged', 'true');
          localStorage.setItem('access-token', response.token);
          localStorage.setItem('email', response.email);
          localStorage.setItem('name', response.user);
          const to = String(this.$route.query.returnUrl ?? '/');
          await this.$router.push(to);
        }
      } catch (e) {
        this.hidden = false;
      }
    },
  },
});
</script>
